import groupBy from 'lodash.groupby'
const CLOUD = 'cloud'
const RESIDENTIAL = 'residential'
const REFRESH_INTERVAL = 300000

export default {
    computed: {
        groupBy: () => groupBy,
        cloud: () => CLOUD,
        residential: () => RESIDENTIAL,
        refreshInterval: () => REFRESH_INTERVAL,
        activeCanteen() {
            return this.$store.getters['active/canteen']
        },
        hasCC() {
            return this.cloudCanteenAddresses.length > 0
        },
        hasRC() {
            return this.residentialCanteenAddresses.length > 0 && !this.$user.onlyCloudCanteen
        },
        cloudCanteenAddresses() {
            return Object.entries(groupBy(this.$user?.canteens, 'address')).map(
                ([address, canteens]) => {
                    return {
                        id: this.getId(address),
                        address: this.$addresses.findItem(this.getId(address))?.model,
                        canteens: canteens.map((canteen) => {
                            canteen.cutoff_date = this.$moment(canteen.delivery_time).format(
                                'YYYY_MM_DD'
                            )
                            return canteen
                        }),
                        restaurants: canteens.reduce((a, c) => {
                            c.restaurants.forEach((restaurant) => {
                                if (a.findIndex((r) => r.id === restaurant.id) === -1)
                                    a.push(restaurant)
                            })
                            return a
                        }, []),
                    }
                }
            )
        },
        residentialCanteenAddresses() {
            return Object.entries(
                groupBy(this.$store.getters['canteen/residentialList'] || [], 'address.id')
            ).map(([address, canteens]) => {
                return {
                    id: address,
                    address: canteens[0].address,
                    canteens: canteens.map((canteen) => {
                        canteen.cutoff_date = this.$moment(canteen.delivery_time).format(
                            'YYYY_MM_DD'
                        )
                        return canteen
                    }),
                    restaurants: canteens.reduce((a, c) => {
                        c.restaurants.forEach((restaurant) => {
                            if (a.findIndex((r) => r.id === restaurant.id) === -1)
                                a.push(restaurant)
                        })
                        return a
                    }, []),
                }
            })
        },
    },
}
